<template>
  <div class="login" :style="'background-image:url(' + Background + ');'">
    <el-form
      ref="loginFormRef"
      :model="loginFormData"
      :rules="loginFormRules"
      label-position="left"
      label-width="0px"
      class="login-form"
    >
      <h3 class="title">库存管理系统</h3>
      <el-form-item prop="username">
        <el-input
          v-model="loginFormData.username"
          autocomplete="off"
          placeholder="账号"
          clearable
        >
          <template #prefix>
            <svg-icon icon-class="user" class="el-input__icon input-icon" />
          </template>
        </el-input>
      </el-form-item>
      <el-form-item prop="password">
        <el-input
          v-model="loginFormData.password"
          type="password"
          autocomplete="off"
          placeholder="密码"
          @keyup.enter.native="handleLogin"
        >
          <template #prefix>
            <svg-icon icon-class="password" class="el-input__icon input-icon" />
          </template>
        </el-input>
      </el-form-item>
      <el-form-item style="width: 100%">
        <el-button
          :loading="loading"
          size="default"
          type="primary"
          style="width: 100%"
          @click="handleLogin"
        >
          <span v-if="!loading">登 录</span>
          <span v-else>登 录 中...</span>
        </el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script setup>
// import { encrypt } from "@/utils/rsaEncrypt";
// import Config from "@/settings";
// import { getCodeImg } from "@/api/login";
// import Cookies from "js-cookie";
// import qs from "qs";
import Background from "@/assets/images/background.webp";
import { ref, watch } from "vue";
import md5 from "md5";
import useAccountStore from "@/store/modules/account";
import { useRouter, useRoute } from "vue-router";
import usePermissionStore from "@/store/modules/permission";
import { setCacheData } from "@/utils/auth";

const accountStore = useAccountStore();
const permissionStore = usePermissionStore();
const router = useRouter();
const route = useRoute();

const redirect = ref(undefined);

watch(
  route,
  (newRoute) => {
    redirect.value = newRoute.query && newRoute.query.redirect;
  },
  { immediate: true }
);

const loginFormRef = ref(null);
const loginFormData = ref({
  username: "",
  password: "",
});

const loading = ref(false);

const loginFormRules = {
  username: [{ required: true, trigger: "blur", message: "用户名不能为空" }],
  password: [{ required: true, trigger: "blur", message: "密码不能为空" }],
};

const handleLogin = () => {
  // 校验数据
  loginFormRef.value.validate((valid) => {
    // 不合规直接返回
    if (!valid) return;
    //
    loading.value = true;
    accountStore
      .login({
        userAccount: loginFormData.value.username,
        userPassword: md5(loginFormData.value.password),
      })
      .then((res) => {
        if (loginFormData.value.password === "123456") {
          setCacheData("simplePassword", true);
          accountStore.simplePassword = true;
        } else {
          setCacheData("simplePassword", false);
          accountStore.simplePassword = false;
        }
        router.push({ path: redirect.value || "/" });
      })
      .catch((res) => {})
      .finally(() => {
        loading.value = false;
      });
  });
};
</script>

<style rel="stylesheet/scss" lang="scss">
.login {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  background-size: cover;
}
.title {
  margin: 0 auto 30px auto;
  text-align: center;
  color: #707070;
}

.login-form {
  border-radius: 6px;
  background: #ffffff;
  width: 385px;
  padding: 25px 25px 5px 25px;
  .el-input {
    height: 38px;
    input {
      height: 38px;
    }
  }
  .input-icon {
    height: 39px;
    width: 14px;
    margin-left: 2px;
  }
}
</style>
